import { ScopeOfPracticeEnum } from '@umss/shared/utils';
import { FacilityDto } from '../../facilities/facility.model';

export interface FacilityReviewDetailDto {
  scopeOfPractice?: ScopeOfPracticeEnum;

  facility: FacilityDto;

  /**
   * format: int32
   */
  score?: number;

  comment?: string;

  /**
   * format: date-time
   */
  createdAt?: string;

  /**
   * format: date-time
   */
  updatedAt?: string;
}

export interface FacilityReviewParams {
  scopeOfPractice?: ScopeOfPracticeEnum;
  score?: number;
}
